import client from './client';

export const authApi = {
  login(email, password) {
    return client.post('/auth/login', { email, password });
  },
  register(data) {
    return client.post('/auth/register', data);
  },
  refresh(refreshToken) {
    return client.post('/auth/refresh', { refresh_token: refreshToken });
  },
  logout() {
    return client.post('/auth/logout');
  },
  getProfile() {
    return client.get('/users/me');
  },
};
